export const Red = {
  primary: '#EE3E5C',
  secondary: '#FEF4F6',
  tertiary: '#E7EAEC',
};

export const TextColors = {
  primary: '#0E3145',
  secondary: '#6E838F',
};
